import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { formatTagBsk } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-add-tagbsk',
    templateUrl: './add-tagbsk.component.html',
    styleUrls: ['./add-tagbsk.component.scss'],
})
export class AddTagBskComponent implements OnInit {

    @Input()
    public tagList = [];

    @Input()
    public basketList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;


    constructor(private api: ApiV6Service, protected _messageService: MessagesService,
        private translate: TranslateService) {
    }

    ngOnInit() {
    }

    public async validate (request) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        const wdata = formatTagBsk(request, 0, []);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatetagbsk', wdata));
            this.onValidate.emit({ data: wRes.data, create: true });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
